'use client'

import { useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { Modal } from '@/Modal'

export const Gallery = ({ title, images }: GalleryProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)

  if (images.length === 0) {
    return null
  }

  const openAt = (index: number) => {
    setActiveIndex(index)
    setIsOpen(true)
  }

  const goPrevious = () => {
    setActiveIndex(prev => (prev - 1 + images.length) % images.length)
  }

  const goNext = () => {
    setActiveIndex(prev => (prev + 1) % images.length)
  }

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {images.map((image, index) => (
          <button
            key={image.src}
            type="button"
            onClick={() => openAt(index)}
            className="overflow-hidden rounded-md border-2 border-[#a41816] hover:opacity-90 transition-opacity"
            aria-label={`Open ${title} image ${index + 1}`}
          >
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="5xl"
        showCloseButton={true}
        className="m-4"
      >
        <div className="relative bg-black p-3 md:p-4">
          {images.length > 1 && (
            <>
              <button
                type="button"
                onClick={goPrevious}
                className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2"
                aria-label="Previous image"
              >
                <ChevronLeftIcon className="w-5 h-5 text-black" />
              </button>
              <button
                type="button"
                onClick={goNext}
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2"
                aria-label="Next image"
              >
                <ChevronRightIcon className="w-5 h-5 text-black" />
              </button>
            </>
          )}

          <img
            src={images[activeIndex].src}
            alt={images[activeIndex].alt}
            className="w-full max-h-[80vh] object-contain"
          />
        </div>
      </Modal>
    </>
  )
}

interface GalleryProps {
  title: string
  images: Array<{
    src: string
    alt: string
  }>
}
